// core/redux/incomePaymentsFilters.slice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Filtres
  dateRange: [null, null], // ISO strings ou null
  reference: '',
  paymentModeId: null,
  status: null,
customerName: '',
  // Pagination
  pagination: {
    current: 1,
    pageSize: 20,
  },
};

const incomePaymentsFiltersSlice = createSlice({
  name: 'incomePaymentsFilters',
  initialState,
  reducers: {
    setIncomePaymentsDateRange(state, action) {
      // payload: [startIsoOrNull, endIsoOrNull]
      state.dateRange = action.payload || [null, null];
      state.pagination.current = 1; // reset page quand filtre change
    },
    setIncomePaymentsReference(state, action) {
      state.reference = action.payload || '';
      state.pagination.current = 1;
    },
    setIncomePaymentsPaymentMode(state, action) {
      state.paymentModeId = action.payload ?? null;
      state.pagination.current = 1;
    },
    setIncomePaymentsStatus(state, action) {
      state.status = action.payload ?? null;
      state.pagination.current = 1;
    },
    setIncomePaymentsPagination(state, action) {
      const { current, pageSize } = action.payload;
      if (typeof current === 'number') state.pagination.current = current;
      if (typeof pageSize === 'number') state.pagination.pageSize = pageSize;
    },
    setIncomePaymentsCustomerName: (state, action) => {
  state.customerName = action.payload ?? '';
},
    resetIncomePaymentsFilters(state) {
      state.dateRange = [null, null];
      state.reference = '';
      state.customerName = '';
      state.paymentModeId = null;
      state.status = null;
      state.pagination = { current: 1, pageSize: 20 };
    },
  },
});

export const {
  setIncomePaymentsDateRange,
  setIncomePaymentsReference,
  setIncomePaymentsPaymentMode,
  setIncomePaymentsStatus,
  setIncomePaymentsPagination,
  resetIncomePaymentsFilters,
  setIncomePaymentsCustomerName,
} = incomePaymentsFiltersSlice.actions;

export default incomePaymentsFiltersSlice.reducer;